import Header from './components/Header';
import Footer from './components/Footer';
import HeroSection from './components/HeroSection';
import { AppSection, AboutSection, CardsSection, CarouselSection } from './components/SectionsA';
import { FaqSection, CommentsSection, MediaSection, IndexSection } from './components/SectionsB';
import { FeaturesSection, UpdatesSection, TopicsSection, RankingSection, ContactSection } from './components/SectionsC';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <HeroSection />
        <AppSection />
        <AboutSection />
        <CardsSection />
        <CarouselSection />
        <FaqSection />
        <CommentsSection />
        <MediaSection />
        <IndexSection />
        <FeaturesSection />
        <UpdatesSection />
        <TopicsSection />
        <RankingSection />
        <ContactSection />
      </main>
      <Footer />
    </>
  );
}